import PureTimed from './PureTimed';
import { connect } from 'react-redux';
import * as actions from './actions';

const mapStateToProps = (state, ownProps) => {
  const attachment = state.attachments[ownProps.id];
  const thumbUrl = attachment ? attachment.large_url : null;
  const dimensions = attachment ? attachment.dimensions : {};
  const url = attachment ? attachment.full_url : null;

  return {
    thumbUrl,
    url,
    dimensions
  };
};

const mapDispatchToProps = (dispatch, { _type, id: questionId }) => (
  {
    setDomain: ({ width, height }) => dispatch(actions.setDomain({ width, height }, questionId)),
    onClose: () => dispatch(actions.close(questionId)),
    onOpen: ()  => dispatch(actions.open(questionId))
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(PureTimed);
